export default "__VITE_ASSET__DacQg3ax__"